// TelcoTrack - Core Module
// Contains singleton services, guards, and core functionality

import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// Services
import { ThemeService } from './services/theme.service';
import { AuthService } from './services/auth.service';
import { NotificationService } from './services/notification.service';
import { ErrorHandlingService } from './services/error-handling.service';
import { LoggerService } from './services/logger.service';


// Interceptors
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { PerfInterceptor } from './interceptors/perf.interceptor';

// Utilities
import { throwIfAlreadyLoaded } from './utils/module-import.guard';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    // Core services (singletons)
    ThemeService,
    AuthService,
    NotificationService,
    ErrorHandlingService,
    LoggerService,

    // HTTP Interceptors
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PerfInterceptor,
      multi: true
    }
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
